import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { STATUS_VARIANT_HIGHLIGHT } from '@/components/StatusWrapper/const';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';

type SubscriptionPendingCancellationDateType = {
  date: string;
};

export const SubscriptionPendingCancellationDate = ({ date }: SubscriptionPendingCancellationDateType) => {
  const cancellationDate = formatDate(date, 'MMM, dd');

  return <StatusWrapper variant={STATUS_VARIANT_HIGHLIGHT.GREY}>Cancels {cancellationDate}</StatusWrapper>;
};
